import serviceAreaCategoryApi from "@/api/serviceAreaCategory";

export default {
  actions: {
    async create({ commit, dispatch, state }, data) {
      const record = await serviceAreaCategoryApi.create(data);
      commit("setRecord", record);
      await dispatch("list");

      return state.record;
    },
    async list({ commit }) {
      const response = await serviceAreaCategoryApi.list();
      commit("setList", response.data.result);
    },
    async fetchRecord({ commit }, id) {
      const response = await serviceAreaCategoryApi.get(id);
      commit("setEdit", Object.assign({}, response.data.result));
      commit("setRecord", Object.assign({}, response.data.result));
    },
    async resetEdit({ commit }, record) {
      commit("setEdit", Object.assign({}, record));
    },
    async update({ commit, dispatch, state }, data) {
      const record = await serviceAreaCategoryApi.update(data);
      commit("setRecord", record);
      await dispatch("list");
      return state.record;
    },
  },
  getters: {
    getById: state => findId => {
      return state.list.find(({ id }) => id === findId);
    },
  },
  mutations: {
    setEdit(state, category) {
      state.edit = category;
    },
    setRecord(state, category) {
      state.record = category;
    },
    setList(state, list) {
      state.list = list;
    },
  },
  namespaced: true,
  state: {
    edit: {},
    list: [],
    record: {},
  },
};
